import React, { createContext, useContext, useState } from 'react';
import { ParkingCardData } from '../../components/CardsComponents/types';

const ParkingContext = createContext<{
  parking: ParkingCardData | null;
  setParking: (parking: ParkingCardData | null) => void;
  selectedOption: 'full' | 'installment';
  setSelectedOption: (option: 'full' | 'installment') => void;
}>({ parking: null, setParking: () => {}, selectedOption: 'full', setSelectedOption: () => {} });

export const ParkingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [parking, setParking] = useState<ParkingCardData | null>(null);
  const [selectedOption, setSelectedOption] = useState<'full' | 'installment'>('full');

  return (
    <ParkingContext.Provider value={{ parking, setParking, selectedOption, setSelectedOption }}>
      {children}
    </ParkingContext.Provider>
  );
};

export const useParking = () => useContext(ParkingContext);